import React from 'react';

import CLocalizedText from '../../components/CLocalizedText';
import CLocalizedTextString from '../../components/CLocalizedTextString';
import CPageModule from '../../components/CPageModule';
import Page from '../../components/layout/Page';
import CPerformancePlotAndTable from './CPerformancePlotAndTable';


export default function PPerformance() {

  return (
    <Page title={CLocalizedTextString('fsovP2Performance')}>
      <CPageModule fullWidth>
        <CPageModule submodule>
          <h2>
            <CLocalizedText dictKey={'fsperfP1H1'} />
          </h2>
          <p>
            <CLocalizedText dictKey={'fsperfP1Desc1'} />
          </p>
        </CPageModule>
        <CPerformancePlotAndTable defaultStartDate={'2024-05-22'}/>
      </CPageModule>
    </Page>
  );
}